const printView = () => import('../views/main/printView.vue')
const pjothernotice = () => import('@/views/pjnotice/pjothernotice')
const pjBiddingNotice = () => import('@/views/pjnotice/pjBiddingNotice')
const cgBiddingNotice = () => import('@/views/pjnotice/cgBiddingNotice')
const pbrCenterDY = () => import('@/views/pjnotice/pbrCenterDY')
const projectReportP = () => import('@/views/pjnotice/projectReportP')
const pjnoticebypid = () => import('@/views/pjnotice/pjnoticebypid')
const projectMeetingP = () => import('@/views/print/projectMeetingP')
const printingPreview = () => import('@/views/jjgl/printingPreview')
const settlemanetPrint = () => import('@/views/bbzx/settlemanetPrint.vue')
const settlemanetXMYPrint = () => import('@/views/bbzx/settlemanetXMYPrint.vue')
const viewptc = () => import('@/views/jjgl/viewptc')
const contentview = () => import('@/views/bbgl/contentview')


export default [{
  path: '/printView',
  component: printView,
  children: [
    {
      path: 'projectMeetingP',
      component: projectMeetingP,
      name: 'projectMeetingP'
    },
    {
      path: 'pjothernotice',
      component: pjothernotice,
      name: 'pjothernotice'
    },
    {
      path: 'cgBiddingNotice',
      component: cgBiddingNotice,
      name: 'cgBiddingNotice'
    },
    {
      path: 'pjBiddingNotice',
      component: pjBiddingNotice,
      name: 'pjBiddingNotice'
    },
    {
      path: 'pbrCenterDY',
      component: pbrCenterDY,
      name: 'pbrCenterDY'
    },
    {
      path: 'projectReportP',
      component: projectReportP,
      name: 'projectReportP'
    },
    {
      path: 'pjnoticebypid',
      component: pjnoticebypid,
      name: 'pjnoticebypid'
    },
    {
      path: 'printingPreview',
      component: printingPreview,
      name: 'printingPreview'
    },
    {
      path: 'settlemanetPrint',
      component: settlemanetPrint,
      name: 'settlemanetPrint'
    },
    {
      path: 'settlemanetXMYPrint',
      component: settlemanetXMYPrint,
      name: 'settlemanetXMYPrint'
    },
    {
      path: 'viewptc',
      component: viewptc,
      name: 'viewptc'
    },
    {
      path:'contentview',
      component: contentview,
      name: 'contentview'
    }
  ]

}]
